import { Metadata } from "next";
import RegisterForm from '@/Component/Auth/Register/RegisterForm'

export const metadata: Metadata = {
    title: "Register | Connector Club",
    description: "",
};

const InfluencerRegisterPage = () => {
  return (
    <RegisterForm />
  )
}

export default InfluencerRegisterPage
